import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.less'
import permissionDirective from '@/directive/permission'

import './permission'

Vue.use(ElementUI, { size: 'medium' })
// 注册权限指令
Vue.directive('permission', permissionDirective)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
